import { DummySubtraction } from '../Tabletop';
import { useK3ModelAndAction } from './useK3ModelAndAction';
import { K3Model } from '@k3/core';
import { Subtraction } from '@react-three/csg';
import { Fragment, useRef } from 'react';
import { Mesh, Object3D } from 'three';

export const TableSubtraction = ({ modelKey }: { modelKey: string }) => {
  const { model, modelAction, component } = useK3ModelAndAction(modelKey);
  const geometryRef = useRef<any>();

  if (!model) {
    return <DummySubtraction />;
  }

  let geometry: any;
  let material: any;
  geometryRef.current?.traverse((child: Object3D) => {
    if (!geometry && child instanceof Mesh) {
      geometry = child.geometry;
      material = child.material;
    }
  });

  return (
    <Fragment>
      <group ref={geometryRef} visible={false}>
        <K3Model
          model={model}
          modelAction={modelAction}
          meshProps={modelAction?.props}
          component={component}
          fileURL={model.path}
        />
      </group>

      {geometry ? (
        <Subtraction
          material={material}
          position={modelAction?.props?.position}
          rotation={modelAction?.props?.rotation}
          scale={modelAction?.props?.scale}
          geometry={geometry}
        />
      ) : (
        <DummySubtraction />
      )}
    </Fragment>
  );
};
